import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from '../../components/layout/AppHeader.jsx';

const NAV = [
  { to: '/security-policies/policies', label: 'Policies', testid: 'security-nav-policies' },
  { to: '/security-policies/explain',  label: 'Explain',  testid: 'security-nav-explain' },
];

export default function SecurityShell() {
  return (
    <div className="hr-shell" data-testid="security-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Security Policies</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} data-testid={n.testid} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
